import React, { useEffect, useState } from 'react';
import { Pressable, Text, Switch, View, TextInput } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import * as colors from 'app/src/styles/colors';

import { UPDATE_SALE_ASSET } from './queries';
import { currency } from './index';

const Container = styled(View)`
  flex-direction: row;
  gap: 10px;
`;

const StyledTextInput = styled(TextInput)`
  border-width: 1px;
  border-color: black;
  padding: 4px;
  width: 100px;
`;

const SaleAssetField = props => {
  const { saleAsset, field, isCurrency, isToggle, asset, offer } = props;

  let savedValue = saleAsset[field];

  if (asset) {
    savedValue = saleAsset.asset[field];
  } else if (offer) {
    savedValue = saleAsset.activeOffer[field];
  }

  if (savedValue && isCurrency) { savedValue = currency(savedValue); }

  useEffect(() => {
    if (savedValue !== value) {
      setValue(savedValue);
    }
  }, [saleAsset]);

  const [value, setValue] = useState(savedValue);
  const [updateSaleAsset] = useMutation(UPDATE_SALE_ASSET);

  const updateField = () => {
    const variables = { id: saleAsset.id };
    if (asset) {
      variables.assetAttributes = { [field]: value };
    } else if (offer) {
      variables.offerAttributes = { [field]: value };
    } else {
      variables[field] = value;
    }

    if (savedValue !== value) {
      updateSaleAsset({ variables });
    }

    if (isCurrency) {
      setValue(currency(value));
    }
  };

  const updateValueAndField = newValue => {
    setValue(newValue);
    updateSaleAsset({
      variables: { id: saleAsset.id, [field]: newValue },
    });
  };

  const handleKeyPress = e => {
    if ('Enter' === e.nativeEvent.key) {
      updateField();
    }
  };

  return (
    <Container>
      {isToggle ? (
        <Switch
          value={value}
          onValueChange={updateValueAndField}
          activeTrackColor={colors.elGreen}
          activeThumbColor={colors.elGray}
          style={{marginHorizontal: 10}}
        />
      ) : (
        <StyledTextInput
          onChange={e => setValue(e.target.value)}
          value={value || ''}
          onKeyPress={handleKeyPress}
          onBlur={updateField}
        />
      )}
    </Container>
  );
};

export default SaleAssetField;
